<template>
  <div class="problemHome">
    <div class="title">
      {{ $t("group_topic_list.title") }}
    </div>
    <a-spin :spinning="isLoading">
	    <div class="problem-content">
		    <b-modal id="modal-create-topic" size="xl" hide-header hide-footer>
			    <create-topic></create-topic>
		    </b-modal>

		    <b-modal id="modal-showDetail" size="xl" hide-header hide-footer>
			    <view-detail :rowTopicItem="rowTopicItem"></view-detail>
		    </b-modal>

		    <b-modal id="modal-edit" size="xl" hide-header hide-footer>
			    <edit-topic :rowTopicItem="rowTopicItem"></edit-topic>
		    </b-modal>
		    <div class="d-flex align-items-center justify-content-between">
			    <b-input-group class="w-25">
				    <b-input-group-prepend is-text>
					    <b-icon icon="search"></b-icon>
				    </b-input-group-prepend>
				    <b-input
						    v-model="fillterData.search"
						    required
						    maxlength="255"
						    :placeholder="$t('group_topic_list.label.placeholder_search')"
						    class=""
						    @change="filterTopic"
				    ></b-input>
			    </b-input-group>
			    <div
					    class="m-0 align-items-center d-flex justify-content-end no-wrap w-50"
			    >
				    <!--<a-popconfirm
						    placement="bottom"
						    ok-text="Submit"
						    cancel-text="Cancel"
						    @confirm="importExcel()"
						    @cancel="cancelImportExcel(e)"
				    >
					    <template slot="title">
						    <h5>Choose excel file</h5>
						    <input id="exportBtn" type="file" @change="checkFile" />
					    </template>
					    <div class="mr-4">
						    <span>{{ $t("question_list.label.import") }}:</span>
						    <b-icon-upload class="icon" style="color:green;"></b-icon-upload>
					    </div>
				    </a-popconfirm>-->
				    <!-- @click="downloadCSV()"  -->
				    <!--<div class="mr-2">
            <span style="color: black">
              {{ $t("question_list.label.export") }}:</span
            >
					    <a @click="export_ques()">
						    <b-icon-download
								    class="icon"
								    style="color:green"
						    ></b-icon-download>
					    </a>
				    </div>-->
			    </div>
                <!-- Import câu hỏi -->
                <!--<div class="create-button" v-b-modal.modal-create-topic>
                    <b-icon-upload class="icon" style="color:green;"></b-icon-upload>
                    Import câu hỏi
                </div>-->
                <!-- tạo mới -->
			    <div class="create-button" v-b-modal.modal-create-topic>
				    <b-icon-plus-circle-fill
						    style="color: green;"
				    ></b-icon-plus-circle-fill>
				    {{ $t("group_topic_list.create_topic") }}
			    </div>
                <!-- xoá -->
                <b-button class="create-button" @click="delMultiExam()" style="    background: transparent; color: #212529;">
                    <ion-icon
                        style="color: red; font-size:20px; margin-right: 2px; margin-bottom: -5px"
                        name="trash-outline"
                    ></ion-icon>
                    {{ $t("group_topic_list.delete_topic") }}
                </b-button>
		    </div>

		    <div class="mt-3 d-flex align-items-center">
			    <div class="d-flex align-items-center">
				    <p class="pr-2">{{ $t("group_topic_list.label.category") }}:</p>
				    <b-form-select
						    @change="filterTopic()"
						    class=""
						    v-model="fillterData.selected.category"
						    :options="categoryTopic"
				    >
					    <template v-slot:first>
						    <b-form-select-option :value="null">
							    {{ $t("teacher_list.option_default") }}
						    </b-form-select-option>
					    </template>
				    </b-form-select>
			    </div>

			    <div class="d-flex align-items-center">
				    <p class="pr-2">{{ $t("group_topic_list.label.type") }}:</p>
				    <b-form-select
						    @change="filterTopic()"
						    class=""
						    v-model="fillterData.selected.typeTopic"
						    :options="typeTopicList"
				    >
					    <template v-slot:first>
						    <b-form-select-option :value="null">
							    {{ $t("teacher_list.option_default") }}
						    </b-form-select-option>
					    </template>
				    </b-form-select>
			    </div>

			    <div class="d-flex align-items-center">
				    <p class="pr-2">
					    {{ $t("group_topic_list.label.difficulty_title") }}:
				    </p>
				    <b-form-select
						    @change="filterTopic()"
						    class=""
						    v-model="fillterData.selected.difficulty"
						    :options="difficultyTopic"
				    >
					    <template v-slot:first>
						    <b-form-select-option :value="null">
							    {{ $t("teacher_list.option_default") }}
						    </b-form-select-option>
					    </template>
				    </b-form-select>
			    </div>
		    </div>

		    <b-table
				    hover
				    class="mt-4 border"
				    id="group-topic-list"
				    :items="getTopicListRes"
				    :fields="fields"
				    responsive
		    >
			    <template v-slot:head()="row" style="width: 100px">
				    <p style="color: #A0AEC0;">{{ $t(row.label) }}</p>
			    </template>
			    <template #cell(index)="data">
                    <input type="checkbox" v-model="selectedListBox" v-if="data.item.is_delete == 0" :value="data"/>
				    {{ data.index + 1 + (pagination.current_page - 1) * 20 }}
			    </template>
			    <template #cell(title)="row">
				    <div v-b-tooltip.hover.topleft :title="row.item.title">
					    {{ row.item.title }}
				    </div>
			    </template>
			    <template #cell(teacher)="row">
				    <div v-b-tooltip.hover.topleft :title="row.item.teacher">
					    {{ row.item.teacher }}
				    </div>
			    </template>
			    <template #cell(category)="row">
          <span
		          v-b-tooltip.hover.topleft
		          v-for="(cate, index) in row.item.category"
		          :key="cate.key"
		          :title="row.item.category + ' '"
		          style="font-size: 12px"
          >
            <template
		            v-if="
                row.item.category.length > 1 &&
                  index !== row.item.category.length - 1
              "
            >{{ cate }},
            </template>
            <template v-else>{{ cate }}</template>
          </span>
			    </template>
			    <template #cell(status)="row">
				    <b-icon
						    v-if="row.item.status == 'Active'"
						    icon="circle-fill"
						    variant="success"
				    ></b-icon>
				    <b-icon v-if="row.item.status == 0" icon="circle-fill"></b-icon>
			    </template>
			    <template v-slot:cell(action)="row">
				    <b-icon
						    icon="eye-fill"
						    @click="hideDetailTopic(row.item.id)"
						    variant="primary"
						    style="margin-right: 10px;"
				    ></b-icon>
				    <b-icon-pencil
						    variant="warning"
						    @click="hideEditTopic(row.item.id)"
						    class="edit"
				    ></b-icon-pencil>
			    </template>
		    </b-table>

		    <b-row>
			    <b-col cols="12">
				    <b-pagination
						    @change="change"
						    :value="pagination.current_page"
						    :total-rows="pagination.total"
						    :per-page="pagination.per_page"
						    aria-controls="group-topic-list"
				    ></b-pagination>
			    </b-col>
		    </b-row>
	    </div>
    </a-spin>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CreateTopic from "./CreateTopicList.vue";
import EditTopic from "./EditGroupTopicList.vue";
import ViewDetail from "./ViewDetailTopPicList.vue";

export default {
  components: {
    CreateTopic,
    EditTopic,
    ViewDetail
  },
  data() {
    return {
			isLoading: false,
      rowTopicItem: "",
      createQues: true,
      createExplain: false,
      infoQues: false,
        selectedListBox: [],
      message: "",
      // typeTopicList: ["Reading", "Writing", "Listening"],
      // numberOfQues: ["4", "5", "6"],
      // statusOfQues: ["Active", "Deactivate"],
      // numberOfAns: ["Multiple Choice", "One Choie"],
      // typeOfCategory: ["English", "Math", "History"],
      selectedTypeCategory: "English",
      selectedTypeQuestion: "Reading",
      totalcharacter: 0,
      newImage: "",
      fillterData: {
        search: "",
        page: 1,
        selected: {
          id: null,
          group_topic: "",
          teacher: "",
          category: null,
          difficulty: null,
          typeTopic: null,
          status: "",
          paginate: 20
        }
      },
      categoryTopic: {},
      difficultyTopic: {},
      typeTopicList: [
        { value: "Reading", text: "Reading" },
        { value: "Writing", text: "Writing" },
        { value: "Listening", text: "Listening" },
        { value: "Speaking", text: "Speaking" },
      ],
      dataQuestion: null,
      fields: [
        {
          key: "index",
          label: "group_topic_list.label.group_id",
          sortable: true,
          sortDirection: "desc",
          class: "text-center px-2 tb-index"
        },
        {
          key: "title",
          label: "group_topic_list.label.group_topic1",
          sortable: true,
          sortDirection: "desc",
          class: "tb-title  px-1"
        },
        {
          key: "teacher",
          label: "group_topic_list.label.teacher",
          sortable: true,
          class: "tb-teacher  px-1"
        },

        {
          key: "category",
          label: "group_topic_list.label.category",
          sortable: true,
          class: "tb-category"
        },
        {
          key: "difficulty",
          label: "group_topic_list.label.difficulty_title",
          sortable: true,
          sortDirection: "desc",
          class: "tb-difficulty"
        },
        {
          key: "type",
          label: "group_topic_list.label.type",
          sortable: true,
          sortDirection: "desc",
          class: ""
        },
        {
          key: "updated_at",
          label: "group_topic_list.label.updated_at",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "status",
          label: "group_topic_list.label.status",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "action",
          label: "group_topic_list.label.action",
          class: "text-center"
        }
      ],
      listproblem: []
    };
  },

  computed: {
    ...mapState("config", ["grade", "category", "difficulty"]),
    ...mapGetters({
      listCategories: "category/categories",
      listquestions: "question/questionResponse",
      pagination: "topics/pagination",
      questionList: "setTime/question",
      getTopicListRes: "topics/topicListRes",
      categoryList: "problemHome/categories",
      getDifficulty: "config/difficulty"
    })
  },
  async created() {
      await this.filterTopic();
    // this.listCategory();
	  await this.$store.dispatch("config/getCategory");
    await this.$store.getters["config/category"];
    // await this.$store.dispatch("problemHome/getListCategoryTest")
	  this.xxxx = this.category;
  },
  methods: {
    async hideDetailTopic(id) {
      this.rowTopicItem = id;
      await this.$store.dispatch("config/getCategory");
      await this.$bvModal.show("modal-showDetail");
    },
    async hideEditTopic(id) {
      this.$bvModal.show("modal-edit");
      this.rowTopicItem = id;
    },
    charCount: function() {
      this.totalcharacter = this.message.length;
    },
    list: function(index) {
      this.fillterData.category = index;
      this.filterTopic();
    },
    change: function(page) {
      this.fillterData.page = page;
      this.filterTopic();
    },
    previewAudio() {
      let audio = document.getElementById("audio-preview");
      let reader = new FileReader();

      reader.readAsDataURL(this.file);
      reader.addEventListener("load", function() {
        audio.src = reader.result;
      });
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.previewAudio();
    },

    getCateOfQues(e) {
      if (e.target.options.selectedIndex > -1) {
        this.selectedTypeQuestion =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
    },
    getTypeOfQues(e) {
      if (e.target.options.selectedIndex > -1) {
        this.selectedTypeCategory =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
    },
    async export_ques(){
      await this.$store.dispatch("topics/exportTopic", this.fillterData);
    },
    checkFile(e) {
      this.file_excel = e.target.files[0];
    },
    async importExcel() {
      let formData = new FormData();
      formData.append("file", this.file_excel);
      await this.$store.dispatch("topics/importTopic", formData);
      this.loading = true;

      if (this.$store.state.topics.topicListRes.code !== 422) {
        await this.filterTopic();
        this.$root.toast(
          this.$t(`msg["C_UC1.2_19"]`),
          "success",
          this.$t(`msg["C_UC2.2_1"]`)
        );
        this.cancelImportExcel();
          this.$root.$loading.finish();
      } else {
        this.$root.toast(
          this.$t(`msg["E_UC3_55"]`),
          "danger",
          //change the response message here
          // this.$t("questions_create.message.data_invalid")
          this.$t(`msg["E_UC2.2_18"]`)
        );
        this.cancelImportExcel();
          this.$root.$loading.finish();
        return;
      }
    },
    cancelImportExcel(e) {
      this.file_excel = "";
      document.getElementById("exportBtn").value = null;
      document.getElementById("exportBtn").innerHTML = null;
    },
    async filterTopic() {
        //this.$root.$loading.start();
      await this.$store.dispatch("config/getDifficulty");
      await this.$store.dispatch("topics/getTopicTest", this.fillterData);
      for (let i = 0; i < this.getTopicListRes.length; i++) {
        let getTime = this.getTopicListRes[i].updated_at;
        let getDay = new Date(getTime).getUTCDate();
        let getMonth = new Date(getTime).getUTCMonth() + 1;
        let getYear = new Date(getTime).getUTCFullYear();
        this.getTopicListRes[i].updated_at =
          getDay + "/" + getMonth + "/" + getYear;
      }

      this.difficultyTopic = [];
      for (let i = 0; i < this.getDifficulty.length; i++) {
        const data = {
          value: this.getDifficulty[i].difficulty,
          text: this.getDifficulty[i].difficulty
        };
        this.difficultyTopic.push(data);
      }

      await this.$store.dispatch("problemHome/getListCategoryTest");
      this.categoryTopic = [];
      for (let i = 0; i < this.categoryList.length; i++) {
        const data = {
          value: this.categoryList[i].category,
          text: this.categoryList[i].category
        };
        this.categoryTopic.push(data);
      }
    },
      async delMultiExam(){
          // tiemtt <tiemtt@gmail.com>
          let str_ids = '';
          this.selectedListBox.forEach(ques => {
              if(ques && ques.item){
                  str_ids += str_ids != '' ? '-group-topic-list-del-' + ques.item.id : ques.item.id;
              }
          });
          if(str_ids == ''){
              this.$root.toast(
                  this.$t(`msg["C_UC8.1_5"]`),
                  "danger",
                  this.$t(`msg["C_UC8.1_6"]`)
              );
              return false;
          }
          if(confirm(this.$t(`msg["C_UC8.1_7"]`)) == true) {
            this.$root.$loading.start();
            await this.$store.dispatch("topics/deleteTopicAction", str_ids);
            if (this.$store.state.topics.deleteTopicRes.code !== 422) {
                await this.filterTopic();
                this.$root.toast(
                    this.$t("commons.label.create_success_title"),
                    "success",
                    this.$t(`msg["C_UC8.1_4"]`)
                );
            } else {
                this.$root.toast(
                    this.$t("commons.message.send_fail"),
                    "danger",
                    this.$t(`msg["${this.$store.state.topics.deleteTopicRes.message}"]`)
                );
            }
            this.$root.$loading.finish();
            return true;
            //   this.$root.$loading.start();
            //   await this.filterTopic();
            //   this.$root.toast(
            //       this.$t("commons.label.create_success_title"),
            //       "success",
            //       this.$t(`msg["C_UC8.1_8"]`)
            //   );
            //   this.$root.$loading.finish();
            //   return true;
          } else {
              return false;
          }
      },
  }
};
</script>

<style type="text/scss">
.problemHome {
  padding-left: 36px;
  padding-right: 36px;
  margin-top: 16px;
}
.problem-content {
  padding: 15px;
  border-radius: 15px;
  background-color: #fff;
}
.pagination {
  justify-content: flex-end;
}
.category-list {
  margin-top: 50px;
  color: purple;
  font-weight: bold;
  text-align: center;
  background-color: white;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
.multiselect__tags {
  min-height: 30px;
  border: 1px solid rgba(189, 186, 186, 0.8);
}
.active_category {
  background-color: purple !important;
  color: white;
}
.list-category {
  margin-left: 5px;
  display: inline-block;
  padding: 5px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 3px;
  width: 70px;
  word-break: break-all;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
.list-category:hover {
  color: white;
  background: purple;
  transition: 0.3s;
}
.wrap-category {
  margin: 20px 0 0 -5px;
}
.second-header {
  display: flex;
}
.data-inport-export {
  display: -webkit-inline-box;
  font-size: 20px;
  border: none;
}
.options {
  display: flex;
}
.create-button {
  font-size: 15px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: 0.4s;
  padding: 7px 15px;
  margin-top: 0px;
}
.create-button:hover {
  cursor: pointer;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  transition: 0.4s;
}
.icon {
  color: red;
  font-size: 19px;
  margin-left: 14px;
}
.title {
  font-weight: bold;
  font-size: 25px;
  color: #0770ab;
  text-align: left;
  margin-bottom: 15px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.edit:hover {
  cursor: pointer;
}

/* #modal-showDetail .modal-dialog,
#modal-create-topic .modal-dialog,
#modal-edit .modal-dialog{
  margin-top: 15rem;
} */

.border-table {
  border: 1px solid #c4c4c4;
}

#group-topic-list tbody tr td,
#group-topic-list tbody tr td div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  font-size: 12px !important;
  max-width: 150px;
}

#group-topic-list tbody tr .tb-title,
#group-topic-list tbody tr .tb-teacher,
#group-topic-list tbody tr .tb-category {
  max-width: 150px;
}
.custom-select {
  margin-right: 10px;
  width: 100px;
  background: #fff
    url(https://img.icons8.com/external-tanah-basah-basic-outline-tanah-basah/24/000000/external-chevron-arrows-tanah-basah-basic-outline-tanah-basah-4.png)
    no-repeat right 0.75rem center/8px 10px !important;
}

@media only screen and (max-width: 1366px) {
  #modal-showDetail .modal-dialog,
  #modal-create-topic .modal-dialog,
  #modal-edit .modal-dialog {
    margin-top: 5rem;
  }
}

#group-topic-list thead tr th p {
  font-size: 13px;
}
.justify-content-end.w-50{
    width: 50% !important;
}
</style>
